module.exports = __webpack_public_path__ + "img/filledu_LOGO_loading.b772c90b.png";